import { render } from "./YoutubeShow.vue?vue&type=template&id=6e58a7de"
import script from "./YoutubeShow.vue?vue&type=script&lang=js"
export * from "./YoutubeShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__